import React from 'react';

function CaretIcon({
  className,
}: BaseIcon): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 16 8"
    >
      <g
        strokeWidth="1"
        fillRule="evenodd"
      >
        <g
          transform="translate(-528.000000, -881.000000)"
          fill="#0E0E11"
          fillRule="nonzero"
        >
          <g transform="translate(528.000000, 881.000000)">
            <path d="M8,8 C7.878,8 7.755,7.955 7.659,7.865 L0.159,0.865 C-0.043,0.677 -0.054,0.36 0.135,0.159 C0.324,-0.042 0.641,-0.053 0.841,0.135 L8,6.816 L15.159,0.134 C15.359,-0.054 15.677,-0.043 15.865,0.158 C16.053,0.359 16.043,0.676 15.841,0.864 L8.341,7.864 C8.245,7.955 8.122,8 8,8 Z" />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default CaretIcon;
